'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './settings-list.routes';

export class SettingsListComponent {
  constructor(Auth, SettingsService, dialogs, Config, $uibModal) {
    'ngInject';

    this.undeletable = Config.getPlatformConfig().getSystemSettings();

    this.SettingsService = SettingsService;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    this.SettingsService.query((data) => {
      this.data = data.filter(setting => {
        return !setting.name.startsWith("$");  // remove all the special settings from the list
      });
    }, err => {
      console.log("Could not retrieve settings.")
    })
  }

  isUndeletable(name) {
    return this.undeletable.indexOf(name) !== -1;
  }

  isNoTableDataSetting(settings) {
    return !settings.name.endsWith("-data");
  }

  delete(settings) {
    var that = this;

    var settingsText = "<br/><br/><b>" + settings.name + "</b><br/><p>" + settings.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Settings?", "Do you really want to delete the settings?" + settingsText);
    dlg.result.then(() => {
      // OK delete it
      that.SettingsService.delete({id: settings._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== settings._id;
          });
        },
        err => {
          alert("Could not delete settings");
        });
    }, () => {
      // Cancel
    });
  }

  openPreviewModal(settings) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'jsonViewer',
      resolve: {
        config: function() {
          return {
            data: settings.data
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function () { /* ok */ },
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduu.ap.settings.list', [uiRouter])
  .config(routes)
  .component('settingsList', {
    template: require('./settings-list.html'),
    controller: SettingsListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/settings/list/settings-list.component.js